import React, { useState, useEffect } from "react";
import LegacyBenchmark from "./LegacyBenchmark";
import SpectrumAwardsExcelGrid from "./SpectrumAwardsExcelGrid";
import APIFunctions from "../utils/APIFunctions";
import { checkIsAdminToken } from "../utils/common";

const Benchmark = (props) => {
    const [useNewGrid, setUseNewGrid] = useState(null);
    const [isTogglingMode, setIsTogglingMode] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const isAdmin = checkIsAdminToken();

    useEffect(() => {
        APIFunctions.getBenchmarksGridMode()
            .then((resp) => setUseNewGrid(!!resp?.data?.data?.useNewGrid))
            .catch((err) => {
                console.error(err);
                setUseNewGrid(false);
            });
    }, []);

    const handleToggleMode = () => {
        const newValue = !useNewGrid;
        setIsTogglingMode(true);

        APIFunctions.setBenchmarksGridMode(newValue)
            .then((resp) => {
                if (resp?.data?.success) {
                    setUseNewGrid(newValue);
                } else {
                    alert(resp?.data?.message || "Failed to update setting.");
                }
            })
            .catch((err) => {
                console.error(err);
                alert("An error occurred while updating the setting.");
            })
            .finally(() => setIsTogglingMode(false));
    };

    if (useNewGrid === null) return null;

    return (
        <>
            {isAdmin && (
                <div
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: 0,
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                >
                    <div
                        style={{
                            maxWidth: isHovered ? "220px" : "0px",
                            opacity: isHovered ? 1 : 0,
                            overflow: "hidden",
                            transition: "max-width 0.25s ease, opacity 0.2s ease",
                            background: "#ffffff",
                            border: "1px solid rgba(10,110,143,0.3)",
                            borderRight: "none",
                            borderRadius: "8px 0 0 8px",
                            boxShadow: "-2px 2px 8px rgba(0,0,0,0.12)",
                            padding: isHovered ? "10px 14px" : "0px",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <div style={{ fontSize: "11px", color: "#555", marginBottom: "6px" }}>
                            {useNewGrid ? "New Grid Active" : "Legacy View Active"}
                        </div>
                        <button
                            onClick={handleToggleMode}
                            disabled={isTogglingMode}
                            style={{
                                background: "rgb(10,110,143)",
                                color: "white",
                                border: "none",
                                borderRadius: "12px",
                                padding: "4px 12px",
                                fontSize: "11px",
                                cursor: isTogglingMode ? "not-allowed" : "pointer",
                                opacity: isTogglingMode ? 0.7 : 1,
                                width: "100%",
                            }}
                        >
                            {isTogglingMode ? "Switching..." : useNewGrid ? "Switch to Legacy" : "Switch to New Grid"}
                        </button>
                    </div>

                    <div
                        style={{
                            width: "28px",
                            height: "56px",
                            background: "rgb(10,110,143)",
                            borderRadius: "50% 0 0 50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "-2px 0 6px rgba(0,0,0,0.15)",
                            transition: "width 0.25s ease",
                        }}
                        title={useNewGrid ? "New Grid Active — click to switch" : "Legacy View Active — click to switch"}
                    >
                        <span style={{ color: "white", fontSize: "14px" }}>{useNewGrid ? "N" : "L"}</span>
                    </div>
                </div>
            )}

            {useNewGrid ? <SpectrumAwardsExcelGrid isAdmin={isAdmin} /> : <LegacyBenchmark {...props} />}
        </>
    );
};

export default Benchmark;
